{
  "pageTitle": "Čarobnjak za podešavanje",
  "welcomeDesc": "Hajde da podesimo vaš nalog. Treba samo nekoliko minuta.",
  "stepNumber": "Korak {{number}}",
  "selectProviderLabel": "Izaberite pružaoca usluga",
  "step1Title": "Bankovni podaci",
  "step1Desc": "Dodajte vaše bankovne podatke za obradu plaćanja.",
  "step2Title": "Adresa",
  "step2Desc": "Dodajte adresu na koju se šalju računi.",
  "step3Title": "Pružalac usluga",
  "step3Desc": "Povežite vašeg pružaoca usluga (struja, internet, itd.).",
  "next": "Dalje",
  "back": "Nazad",
  "finish": "Završi podešavanje",
  "skip": "Preskoči za sada",
  "bankName": "Naziv banke",
  "bankNamePlaceholder": "npr. ASA, Procredit",
  "bankType": "Vrsta banke",
  "bankASA": "ASA",
  "bankProcredit": "Procredit",
  "bankUsername": "Korisničko ime banke",
  "bankUsernamePlaceholder": "Vaše korisničko ime banke",
  "bankPassword": "Lozinka banke",
  "bankPasswordPlaceholder": "Vaša lozinka banke",
  "addressName": "Naziv adrese",
  "addressNamePlaceholder": "npr. Kuća, Kancelarija",
  "selectProvider": "Izaberite pružaoca",
  "providerUsername": "Korisničko ime pružaoca",
  "providerUsernamePlaceholder": "Korisničko ime računa pružaoca",
  "providerPassword": "Lozinka pružaoca",
  "providerPasswordPlaceholder": "Lozinka računa pružaoca",
  "skipPayment": "Preskoči plaćanje za ovog pružaoca",
  "taxDeduction": "Omogući poreski odbitak",
  "taxDeductionAmount": "Iznos poreskog odbitka (KM)",
  "loadingProviders": "Učitavanje pružalaca...",
  "creatingBank": "Kreiranje banke...",
  "creatingAddress": "Kreiranje adrese...",
  "assigningProvider": "Dodjeljivanje pružaoca...",
  "completingSetup": "Završavanje podešavanja...",
  "bankCreated": "Bankovni podaci dodati",
  "addressCreated": "Adresa dodata",
  "providerAssigned": "Pružalac povezan",
  "setupComplete": "Podešavanje završeno! Preusmjeravanje na dashboard...",
  "createBankError": "Neuspješno kreiranje banke",
  "createAddressError": "Neuspješno kreiranje adrese",
  "assignProviderError": "Neuspješno dodjeljivanje pružaoca",
  "completeSetupError": "Neuspješno završavanje podešavanja",
  "loadProvidersError": "Neuspješno učitavanje pružalaca",
  "checkmark": "✓",
  "stepPlaceholder": "",
  "setupCompleteMsg": "Podešavanje završeno! Preusmjeravanje na dashboard..."
}
